import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppDefaultComponent } from './@core/app-default/app-default/app-default.component';
import { CheckAuthComponent } from './@pages/check-auth/check-auth.component';
import { AppImmersiveComponent } from './@core/app-immersive/app-immersive/app-immersive.component';
import { AppBlankComponent } from './@core/app-blank/app-blank/app-blank.component';

const routes: Routes = [
  {
    path: '',
    component: CheckAuthComponent,
  },
  {
    /*TODO: Modularizar demais itens */
    path: '',
    loadChildren: () => import('src/app/@feature/main/main.module').then(m => m.MainModule)
  },
  {
    path: 'unauthorized',
    component: AppDefaultComponent,
    loadChildren: () => import('./@feature/nopermission/nopermission.module').then(m => m.NoPermissionModule)
  },
  {
    path: 'login',
    loadChildren: () => import('./@feature/login/login.module').then(m => m.LoginModule)
  },
  {
    path: 'dashboard',
    component: AppDefaultComponent,
    loadChildren: () => import('./@feature/dashboard/dashboard.module').then(m => m.DashboardModule)
  },
  {
    path: 'outros/notificacoes',
    component:AppDefaultComponent,
    loadChildren: () => import('./@feature/notificacoes/notificacoes.module').then(m => m.NotificacoesModule)
  },
  {
    path: 'cadastro',
    component: AppDefaultComponent,
    loadChildren: () => import('src/app/@feature/cadastro/cadastro.module').then(m => m.CadastroModule)
  },
  {
    path: 'coleta',
    component: AppDefaultComponent,
    loadChildren: () => import('./@feature/coleta/coleta.module').then(m => m.ColetaModule)
  },
  {
    path: 'consultas',
    component: AppDefaultComponent,
    loadChildren: () => import('./@feature/consultas/consultas.module').then(m => m.ConsultasModule)
  },
  // {
  //   path: 'consultas',
  //   component: AppImmersiveComponent,
  //   loadChildren: () => import('src/app/@feature/consulta-detalhada/consulta-detalhada.module').then(m => m.ConsultaDetalhadaModule)
  // },
  {
    path: 'documentos-fiscais',
    component: AppImmersiveComponent,
    loadChildren: () => import('./@feature/documentos-fiscais/documentos-fiscais.module').then(m => m.DocumentosFiscaisModule)
  },
  // {
  //   path: 'gaiola',
  //   component: AppDefaultComponent,
  //   loadChildren: () => import('./@feature/gaiola/gaiola.module').then(m => m.GaiolaModule)
  // },
  {
    path: 'relatorio',
    component: AppDefaultComponent,
    loadChildren: () => import('./@feature/relatorios/relatorios.module').then(m => m.RelatoriosModule)
  },
  // {
  //   path: 'manifesto-transferencia',
  //   component: AppDefaultComponent,
  //   loadChildren: () => import('./@feature/manifesto-transferencia/manifesto-transferencia.module').then(m => m.ManifestoTransferenciaModule)
  // },
  // {
  //   path: 'manifesto-embarque',
  //   component: AppDefaultComponent,
  //   loadChildren: () => import('./@feature/manifesto-embarque/manifesto-embarque.module').then(m => m.ManifestoEmbarqueModule)
  // },
  {
    path: 'configuracoes',
    component: AppDefaultComponent,
    loadChildren: () => import('./@feature/configuracoes/configuracoes.module').then(m => m.ConfiguracoesModule)
  },
  {
    path: 'gerencia-arquivo',
    component: AppDefaultComponent,
    loadChildren: () => import('./@feature/gerencia-arquivo/gerencia-arquivo.module').then(m => m.GerenciaArquivoModule)
  },
  {
    path: 'impressoes',
    component: AppDefaultComponent,
    loadChildren: () => import('./@feature/impressoes/impressoes.module').then(m => m.ImpressoesModule)
  },
    {
    path: 'integrador',
    component: AppDefaultComponent,
    loadChildren: () => import('./@feature/integrador/integrador.module').then(m => m.IntegradorModule)
  },
  {
    path: 'notificacoes',
    component: AppDefaultComponent,
    loadChildren: () => import('./@feature/notificacoes/notificacoes.module').then(m => m.NotificacoesModule)
  },
  // {
  //   path: 'transferencias/manifesto-transferencia/garagem',
  //   component: AppDefaultComponent,
  //   loadChildren: () => import('./@feature/garagem/garagem.module').then(m => m.GaragemModule)
  // },
  {
    path: 'pre-manifesto',
    component: AppDefaultComponent,
    loadChildren: () => import('./@feature/pre-manifesto/pre-manifesto-transferencia.module').then(m => m.PreManifestoTransferenciaModule)
  },
  {
    path: 'print', // Componente de impressão deve nascer em um template vazio.
    component: AppBlankComponent,
    loadChildren: () => import('./@feature/print/print.module').then(m => m.PrintModule)
  },
  {
    path: 'app2', // Tela de consulta sem menu, com breadcrumb.
    component: AppImmersiveComponent,
    loadChildren: () => import('./@feature/rastreamento/rastreamento.module').then(m => m.RastreamentoModule)
  },
  // {
  //   path: 'relatorio', // Tela de consulta sem menu, com breadcrumb.
  //   component: AppImmersiveComponent,
  //   loadChildren: () => import('./@feature/rastreamento/rastreamento.module').then(m => m.RastreamentoModule)
  // },
  // {
  //   path: 'recepcao-fisica',
  //   component: AppDefaultComponent,
  //   loadChildren: () => import('./@feature/recepcao-fisica/recepcao-fisica.module').then(m => m.RecepcaoFisicaModule)
  // },
  // {
  //   path: 'triagem',
  //   component: AppDefaultComponent,
  //   loadChildren: () => import('./@feature/triagem/triagem.module').then(m => m.TriagemModule)
  // },
  {
    path: 'relatorios',
    component: AppDefaultComponent,
    loadChildren: () => import('src/app/@feature/relatorios/relatorios.module').then(m => m.RelatoriosModule)
  },
  {
    path: 'ptl',
    component: AppDefaultComponent,
    loadChildren: () => import('./@feature/ptl/ptl.module').then(m => m.PtlModule)
  },
  { path: 'paineis/line-haul',
    component: AppDefaultComponent,
    loadChildren: () => import('./@feature/linehaul/linehaul.module').then(m => m.LinehaulModule) 
  },
  {
    path:'atendimento',
    component: AppDefaultComponent,
    loadChildren: () => import('./@feature/atendimento/atendimento.module').then(m => m.AtendimentoModule)
  },
  {
    path: 'gestao',
    component: AppDefaultComponent,
    loadChildren: () => import('./@feature/gestao-estoque/gestao-estoque.module').then(m => m.GestaoEstoqueModule)
  },
  {
    path: 'recebimento',
    component: AppDefaultComponent,
    loadChildren: () => import('./@feature/recebimento/recebimento.module').then(m => m.RecebimentoModule)
  },
  {
    path: 'devolucao',
    component: AppDefaultComponent,
    loadChildren: () => import ('./@feature/devolucao/devolucao.module').then(m => m.DevolucaoModule)
  },
  {
    path: 'entregas',
    component: AppDefaultComponent,
    loadChildren: () => import ('./@feature/entregas/entregas.module').then(m => m.EntregasModule)    
  },
  {
    path: 'transferencias',
    component: AppDefaultComponent,
    loadChildren: () => import ('./@feature/transferencias/transferencias.module').then(m => m.TransferenciasModule)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
